import { render } from "./ServiceLayout.vue?vue&type=template&id=2afc4107&scoped=true"
import script from "./ServiceLayout.vue?vue&type=script&lang=js"
export * from "./ServiceLayout.vue?vue&type=script&lang=js"

import "./ServiceLayout.vue?vue&type=style&index=0&id=2afc4107&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afc4107"]])

export default __exports__